import { render, staticRenderFns } from "./MaintenanceModeLayout.vue?vue&type=template&id=0b40b0f1&"
import script from "./MaintenanceModeLayout.vue?vue&type=script&lang=js&"
export * from "./MaintenanceModeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b40b0f1')) {
      api.createRecord('0b40b0f1', component.options)
    } else {
      api.reload('0b40b0f1', component.options)
    }
    module.hot.accept("./MaintenanceModeLayout.vue?vue&type=template&id=0b40b0f1&", function () {
      api.rerender('0b40b0f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/MaintenanceModeLayout.vue"
export default component.exports